import React, { useState } from 'react';
import styles from './Layout.module.css';

const Layout = ({ children }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className={styles.layout}>
      {/* Background decoration */}
      <div className={styles['background-decoration']}>
        <div className={styles['background-blur']}></div>
      </div>

      {/* Desktop navigation buttons */}
      <div className={styles['nav-buttons']}>
        <div className={styles['nav-button-left']}>
          <button className={styles['nav-button']} aria-label="Home" onClick={() => window.location.href = 'https://foldsofhonor.org'}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
              <polyline points="9 22 9 12 15 12 15 22"/>
            </svg>
          </button>
          <div className={styles['nav-separator']}></div>
        </div>
        <button className={styles['nav-button']} aria-label="Help" onClick={() => window.open('https://foldsofhonor.org/contact', '_blank')}>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
            <line x1="9" y1="9" x2="9.01" y2="9"/>
            <line x1="12" y1="9" x2="12.01" y2="9"/>
            <line x1="15" y1="9" x2="15.01" y2="9"/>
          </svg>
        </button>
      </div>

      {/* Mobile hamburger button */}
      <button
        className={styles['hamburger']}
        aria-label={menuOpen ? 'Close menu' : 'Open menu'}
        aria-expanded={menuOpen}
        onClick={() => setMenuOpen(prev => !prev)}
      >
        {menuOpen ? (
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"/>
            <line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        ) : (
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="3" y1="6" x2="21" y2="6"/>
            <line x1="3" y1="12" x2="21" y2="12"/>
            <line x1="3" y1="18" x2="21" y2="18"/>
          </svg>
        )}
      </button>

      {/* Mobile dropdown menu */}
      {menuOpen && (
        <>
          <div className={styles['menu-overlay']} onClick={() => setMenuOpen(false)} />
          <div className={styles['mobile-menu']}>
            <button
              className={styles['mobile-menu-item']}
              onClick={() => { setMenuOpen(false); window.location.href = 'https://foldsofhonor.org'; }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
                <polyline points="9 22 9 12 15 12 15 22"/>
              </svg>
              Home
            </button>
            <button
              className={styles['mobile-menu-item']}
              onClick={() => { setMenuOpen(false); window.open('https://foldsofhonor.org/contact', '_blank'); }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
                <line x1="9" y1="9" x2="9.01" y2="9"/>
                <line x1="12" y1="9" x2="12.01" y2="9"/>
                <line x1="15" y1="9" x2="15.01" y2="9"/>
              </svg>
              Help
            </button>
          </div>
        </>
      )}

      {/* Page content */}
      <div className={styles.content}>
        {children}
      </div>


    </div>
  );
};

export default Layout;
